/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Label,
  FormGroup,
  Row,
  Input,
  Container,
  CardHeader,
  CardFooter,
  Button,
  Form, FormFeedback
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import axios from 'axios';
import moment from 'moment';
import SimpleHeader from "components/Headers/SimpleHeader.js";

export default function EditAcquirer(props) {
  const token = localStorage.getItem("token");
  const [merchantPk, setMerchantPk] = useState("");
  const [acquirerId, setAcquirerId] = useState("");
  const [subbmited, setSubbmited] = useState("");
  const [acquirers, setAcquirers] = useState([]);
  let history = useHistory();

  const [acquirerNameError, setAcquirerNameError] = useState(null);
  const [subbmitedError, setSubmittedError] = useState(null);

  const validateForm = () => {
    let error = false;
    if (acquirerId === "") {
      setAcquirerNameError("invalid");
      error = true;
    }
    if (subbmited === "") {
      setSubmittedError("invalid");
      error = true;
    }
    return error;
  };

  useEffect(() => {
    getAcquirerById();
  }, []);

  const getAcquirerById = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/mcacquirer/${props.match.params.id}`, {
        method: 'GET', // or 'PUT'
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(),
      })
      const data = await response.json();
      setMerchantPk(data.response_data.merchant_pk);
      getAcquirer(data.response_data.acquirer_id);
      setAcquirerId(data.response_data.acquirer_id);
      setSubbmited(moment(data.response_data.submitted, "DD/MM/YYYY").format("YYYY-MM-DD"));
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const getAcquirer = () => {
    const data = { page: 1, per_page: 100 };
    fetch(`${process.env.REACT_APP_API_BASE_URL}/acquirers`, {
      method: 'POST', // or 'PUT'
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => {
        setAcquirers(data.response_data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  function UpdateData() {
    let data = {
      merchant_pk: parseInt(merchantPk),
      acquirer_id: parseInt(acquirerId),
      submitted: moment(subbmited).format("DD/MM/yyyy")
    }
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/mcacquirer/update/${props.match.params.id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then(function (response) {
        history.push("/admin/customers/daftar-merchant");
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      UpdateData();
    }
  }
  return (
    <>
      <SimpleHeader name="Edit Berkas Dokumen" parentName="Admin" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardBody>
                <Form onSubmit={handleSubmit} >
                  <CardHeader>
                    <h3>Edit Berkas Dokumen</h3>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="serial_number"
                      >
                        Acquirer Name
                        <span className="text-danger">*</span>
                      </Label>
                      <Input
                        disabled
                        id="exampleFormControlSelect3"
                        name="transaction_type"
                        type="select"
                        value={acquirerId}
                        invalid={acquirerNameError === "invalid"}
                        onChange={(e) => {
                          setAcquirerId(e.target.value);
                          if (e.target.value !== "") {
                            setAcquirerNameError("");
                          }
                        }}
                      >
                        <option value={0}>Pilih Acquirer Name</option>
                        {
                          acquirers.map((acquirer, key) => {
                            return <option key={key} value={acquirer.acquirer_id}>{acquirer.acquirer_name}</option>
                          })
                        }
                      </Input>
                      <FormFeedback>Acquirer tidak boleh kosong</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="exampleFormControlInput1"
                      >
                        Subbmited
                        <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="example-date-input"
                        type="date"
                        value={subbmited}
                        invalid={subbmitedError === "invalid"}
                        onChange={(e) => {
                          setSubbmited(e.target.value);
                          if (e.target.value !== "") {
                            setSubmittedError("");
                          }
                        }}
                      />
                      <FormFeedback>Subbmited tidak boleh kosong</FormFeedback>
                    </FormGroup>
                  </CardBody>
                  <CardFooter>
                    <Button color="primary" type="submit">
                      Simpan
                                        </Button>
                    <Link className="btn btn-info" to="/admin/customers/daftar-merchant">
                      Kembali
                                        </Link>
                  </CardFooter>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
